import React from 'react';
import { Button } from '@sweetgreen/garnish';

import { useLocalizationContext } from '@order/Localization';

export const SweetpassCheckoutCta = ({
  testID,
  isLoading,
  hasAccepted,
  handleCta,
}: {
  readonly testID?: string;
  readonly isLoading: boolean;
  readonly hasAccepted: boolean;
  readonly handleCta: () => void;
}) => {
  const { t } = useLocalizationContext();

  return (
    <Button
      testID={testID ?? 'sweetpass.checkout.cta'}
      onPress={handleCta}
      isLoading={isLoading}
      size="large"
      palette="primary"
      disabled={!hasAccepted}
    >
      {t('sweetpass.checkout.upgrade-cta')}
    </Button>
  );
};
